import useAuth from '../hooks/useAuth';
import { useLocation,useParams,useNavigate } from 'react-router-dom';
import Grid from './Grid';

import Header from './Header'
import Knoppie from './Knoppie'
import MyUploader from './MyUploader'

const Upload = () => {

        const auth = useAuth();
        const username = auth.auth.user.username
        const access = auth.auth.user.userRole
        const location = useLocation();
        const from = location.state?.from || "./";
        const type = location.state?.type
        const id = location.state?.id

        console.log(location)

        console.log(type)
        return (
            <>
                <Header username={username} role={access} destination={from}></Header>
                
                <h3>Upload files</h3>

                <MyUploader 
                className={"Dropzone"}
                type={type}
                id={id}
                ></MyUploader>

                


            </>
        )

    }

export default Upload
